import "core-js/modules/es.array.push.js";
import { unitAppDetail } from "@/service/appList";
import baseInfo from "../comp/base-info.vue";
import authorization from "../comp/authorization.vue";
import AppDetailTabAzure from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab-azure.vue";
import AppDetailTab2 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab2.vue";
import AppDetailTab3 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab3.vue";
import AppDetailTab4 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab4.vue";
import AppDetailTab5 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab5.vue";
import AppDetailTab6 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab6.vue";
import AppDetailTab2Third from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab2-third.vue";
import AppDetailTab3Third from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab3-third.vue";
import AppDetailTab7 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab7.vue";
import AppDetailTab8 from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailTab8.vue";
import AppDetailPositionSync from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailPositionSync.vue";
import AppDetailContactSync from "@/views/MGT/AppDetail/AppDetailTabs/AppDetailContactSync.vue";
export default {
  name: "app-appdetail",
  components: {
    baseInfo,
    authorization,
    AppDetailTabAzure,
    AppDetailTab2Third,
    AppDetailTab3Third,
    AppDetailTab2,
    AppDetailTab3,
    AppDetailTab4,
    AppDetailTab5,
    AppDetailTab6,
    AppDetailTab7,
    AppDetailTab8,
    AppDetailPositionSync,
    AppDetailContactSync
  },
  data() {
    return {
      currnetApp: this.$route.query,
      tabValue: "base-info",
      appdetail: {},
      scopeList: []
    };
  },
  methods: {
    goBack() {
      this.$router.push("/MGT/app-mamage");
    },
    async getAppDetail() {
      let {
        id
      } = this.$route.query;
      let res = await unitAppDetail(id);
      let {
        data: {
          result,
          retVal
        }
      } = res;
      if (result == 0) {
        let {
          users
        } = retVal;
        this.appdetail = retVal;
        this.scopeList = users;
      }
    }
  },
  computed: {
    item() {
      let {
        appId
      } = this.appdetail;
      return {
        ...this.appdetail,
        id: appId
      };
    },
    //Azure
    isAzure() {
      return this.appdetail.appId === "ID_AZURE";
    },
    // 自己钉钉
    isDingDing() {
      return this.appdetail.appId === "DING_TALK_SYNC";
    },
    // 第三方钉钉
    _isThirdDingDing() {
      return this.appdetail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.appdetail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE" || this.appdetail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // 企微通讯录同步应用
    _isEnterpriseWechatSync() {
      return this.appdetail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // opera
    _isOperaCloud() {
      return this.appdetail.appId === "ID_OPERA_CLOUD";
      // return false;
    },
    // 需要显示部门管理跟角色管理
    _third() {
      return this._isThirdDingDing || this._isEnterpriseWechat;
    }
  },
  mounted() {
    this.getAppDetail();
  }
};